<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        :width="iconWidth"
        :height="iconHeight"
        viewBox="0 0 52 52" 
        enable-background="new 0 0 52 52" 
        xml:space="preserve"
    >
        <path 
            d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5
            V37.5z"
            fill="currentColor"
        />
        <path 
            d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7
            c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"
            fill="currentColor"
        />
        <path 
            d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6
            c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"
            fill="currentColor"
        />
        <path 
            d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5
            V3.5z"
            fill="currentColor"
        />
    </svg>
</template>